import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { changePassword } from 'redux/users/actions';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';
import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';

import './ChangePasswordForm.css';


function ChangePasswordForm(props) {
   const {
     handleSubmit,
     changePassword,
     changePasswordError,
     oldPassword,
     password,
     password2,
     valid,
   } = props;
   const { t } = useTranslation();

   const _handleSubmit = () => {
    const form = new FormData();
    form.append('old_password', oldPassword);
    form.append('password', password);
    form.append('password2', password2);
    changePassword(form);
  };

  return (
    <div className="change-password-form__component">
      <Form
        onSubmit={handleSubmit(_handleSubmit)}
        error={!valid}
      >
        <Field
          component={TextField}
          name="old_password"
          type="password"
          placeholder={t("Current password")}
          required
        />
        <Field
          component={TextField}
          name="password"
          type="password"
          placeholder={t("New password")}
          required
        />
        <Field
          component={TextField}
          name="password2"
          type="password"
          placeholder={t("Repeat new password")}
          required
        />
        {changePasswordError &&
          <CommonMessage
            error
            errors={changePasswordError}
          />
        }
        <Button small submit>{t("Change Password")}</Button>
      </Form>
    </div>
  );
}

ChangePasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  oldPassword: PropTypes.string,
  password: PropTypes.string,
  password2: PropTypes.string,
  changePasswordError: PropTypes.object,
};

ChangePasswordForm.defaultProps = {
  oldPassword: null,
  password: null,
  password2: null,
  changePasswordError: null,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('ChangePasswordForm');
  return {
    oldPassword: selector(state, 'old_password'),
    password: selector(state, 'password'),
    password2: selector(state, 'password2'),
    changePasswordError: state.usersReducer.changePasswordError,
  };
};

export default connect(
  mapStateToProps,
  {
    changePassword,
  },
)(reduxForm({
  form: 'ChangePasswordForm',
  validate,
})(ChangePasswordForm));
